import { CAMPAGNE_STATUT_TEXTS } from "@common/config";
import { BadgeSeverity } from "@common/dsfr-ui";
import { CampagneStatut } from "@common/services";

export const CAMPAGNE_STATUS_STYLES: Record<CampagneStatut, Attributes> = {
  'EN_COURS': {
    text: CAMPAGNE_STATUT_TEXTS['EN_COURS'].toUpperCase(),
    badgeSeverity: BadgeSeverity.INFO,
  },
  'A_VENIR': {
    text: CAMPAGNE_STATUT_TEXTS['A_VENIR'].toUpperCase(),
    badgeSeverity: BadgeSeverity.INFO
  },
  'ARCHIVEE': {
    text: CAMPAGNE_STATUT_TEXTS['ARCHIVEE'].toUpperCase(),
    badgeSeverity: BadgeSeverity.INFO,
  },
}

interface Attributes {
  text: string;
  badgeSeverity: BadgeSeverity;
}